// Stylesheets
import "./theme.scss";
import "./resources/images/favicon.png";

// Vendor styles and JS (bootstrap)
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';

// JS Utilities (load utility functions before components that use them)
import "./components/analytics/utils.js";
import "./components/analytics/rteLink.js";
import "./components/analytics/headerSearch.js";
import "./components/analytics/form.js";

// Component-specific JS (ensure dependencies are in order)
import "./components/header/js/DropdownUtils.js";
import "./components/header/js/GlobalHeader.js";
import "./components/header/js/NavBar.js";

// Components (the main feature scripts)
import './components/text/text.js';
import './components/carousel/carousel.js';
import "./components/newslisting/newslisting.js";
import "./components/youtube/youtube.js";
import "./components/header/js/search/initializeGlobalSearch.js";

// More Components
import "./components/container/containerUtils.js"
import "./components/accordion/accordion.js";
import "./components/search-results/searchresults.js";


// component Javascript
import xfHeader from "./components/experiencefragment/experiencefragment_header";

const documentReadyFunctions = () => {
  //languageNavigation();
  // xfHeader();
};
const runDocumentReadyFunctions = () => {
  if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
  ) {
    documentReadyFunctions();
  } else {
    requestAnimationFrame(runDocumentReadyFunctions);
  }
};

runDocumentReadyFunctions();
